import {
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogCloseButton,
} from '../ui/dialog';
import { BudgetForm } from '../forms/budget-form';

interface BudgetDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function BudgetDialog({ open, onOpenChange }: BudgetDialogProps) {
  return (
    <DialogRoot open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogBackdrop />
        <DialogPopup>
          <DialogHeader>
            <DialogTitle>Configurar orçamento</DialogTitle>
            <DialogCloseButton />
          </DialogHeader>
          <DialogContent>
            <BudgetForm onClose={() => onOpenChange(false)} />
          </DialogContent>
        </DialogPopup>
      </DialogPortal>
    </DialogRoot>
  );
}
